import AuthService from "js/utils/AuthService";
import { USER_ROLES as Roles } from "js/models/User";

export const calcParams = (match, computedMatch) => {
  const params = {
    inBackOffice: window.location.pathname.indexOf("admin") !== -1
  };

  if (params.inBackOffice) {
    params.idPrograma = parseInt(match.params.id) || match.params.id;
    params.idNoticia =
      parseInt(match.params.idNoticia) || match.params.idNoticia;
    params.edit = match.params.edit;
  } else {
    params.idPrograma = parseInt(localStorage.getItem("idPrograma"));
    params.edit = computedMatch.params.edit;
  }

  params.disabled =
    params.idNoticia !== "new"
      ? !(params.edit === "edit") || !AuthService.hasPerms([Roles.NOTICIA_W])
      : false;

  return params;
};
